var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficePhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1337 5109 c-129 -31 -231 -141 -257 -278 -14 -74 -14 -4468 0 -4542 22 -113 95 -209 198 -257 l57 -27 1225 0 1225 0 57 27 c103 48 176 144 198 257 14 74 14 4468 0 4542 -22 113 -95 209 -198 257 l-57 27 -1205 2 c-683 0 -1221 -3 -1243 -8z m1623 -259 c8 -14 8 -26 0 -40 -10 -19 -21 -20 -400 -20 -379 0 -390 1 -400 20 -8 14 -8 26 0 40 10 19 21 20 400 20 379 0 390 -1 400 -20z m850 -2245 l0 -1965 -1250 0 -1250 0 0 1965 0 1965 1250 0 1250 0 0 -1965z m-1193 -2096 c34 -13 80 -55 99 -91 32 -61 11 -154 -45 -201 -114 -96 -281 -17 -281 133 0 114 122 199 227 159z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficePhone);
export default __webpack_public_path__ + "static/media/OfficePhone.8e37f4d1cc5edef07018c2179d1ca160.svg";
export { ForwardRef as ReactComponent };